import React from "react";
import Spinner from '../../assets/images/spinner.svg'

export const ProgressLoader = ({message}) => (
  <div style={{ textAlign: "center" }}>
    <img className="w-25" src={Spinner} alt="loading"/>
    <p>{message}</p>
  </div>
)
